module.exports = __webpack_public_path__ + "img/x14.8a210f08.jpg";